<template>
  <div class="SDGPage">
    <section class="wrapper">
      <HeaderComponent />
      <section class="cw-main" >
        <SDGPlansComponent />
        <SDGPaginationComponent />
      </section>
      <FooterComponent />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import SDGPaginationComponent from '@/components/SDGPaginationComponent.vue';
import SDGPlansComponent from '@/components/SDGPlansComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import HeaderComponent from '@/components/HeaderComponent';


export default {
  name: 'SDGPage',
  components: {
    HeaderComponent,
    SDGPlansComponent,
    SDGPaginationComponent,
    FooterComponent,

  },


};
</script>

